import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Select, Row, Col} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Table from "@/biz/Table.jsx";
import Modal from '@/components/Modal/Modal';
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from '@/script/runAsync';
import BizNodeTypeTag, { convertToBizNodeTypeName, convertToDppSubTypeName, bizNodeTypeOptions} from "@/components/BizNodeTypeTag/BizNodeTypeTag";

const Dialog = ({ params, value, onOk, multiple = false, ...props }) => {
    const http = useHTTP();
    const [form] = Form.useForm();

    const [prj, setPrj] = useState({});
    const [data, setData] = useState([]);

    const [selectedRows, setSelectedRows] = useState([]); // 选中的对象集合
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setSelectedRows([]);
        qryPrjInfo()
        doSearch();
    }, []);

    const qryPrjInfo = async () => {
        try {
            const data = await runAsync(
                async () => {
                    return await http.get(`/prjs/${params.prjId}`);
                }, {
                    error: { show: false },
                    loading: { show: false },
                    success: { show: false },
                });
            setPrj(data ?? {});
        } catch (err) {
            console.log(err);
        }
    }

    const doSearch = async () => {
        try {
            setLoading(true);
            const formField = await form.validateFields();
            formField.prjId = params.prjId;
            formField.reqType = params.reqType;
            formField.moduleType = params.moduleType;
            formField.stsCodes =  params.stsCodes ?? ['RLS', 'REVISE'];
            formField.freezeFlag = false;
            formField.prjPatternId = params.prjPatternId;
            formField.isrfId = params.isrfId;

            const data = await runAsync(
                async () => {
                    return await http.get(`/isrf/listIsrfReq`, formField);
                }, {
                    error: { content: (err) => `查询失败: ${err.message}` },
                    loading: { show: false },
                    success: { show: false },
                });

            setData(data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const handleOk = () => {
        if (multiple) {
            onOk(selectedRows);
        } else {
            if (selectedRows.length > 0) {
                onOk(selectedRows[0]);
            }
        }
    }

    const doReset = async () => {
        doSearch();
        setSelectedRows([]);
        form.resetFields();
    }

    const rowSelection = {
        type: multiple === false ? 'radio' : 'checkbox',
        selectedRowKeys: selectedRows.map(({ pkid }) => pkid),
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
        },
    }

    const columns = [
        {
            title: '业务需求单编号',
            dataIndex: 'reqNo',
            width: 180,
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        // {
        //     title: '软件SPEC单编号',
        //     dataIndex: 'isrfNo',
        //     width: 180,
        //     ellipsis: true,
        //     filter: <Table.FilterText />,
        // },
        {
            title: '软件SPEC单标题',
            dataIndex: 'isrfName',
            width: 180,
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        {
            title: '增量需求',
            dataIndex: 'reqTitle',
            width: 180,
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        {
            title: '增量类型',
            dataIndex: 'reqType',
            width: 100,
            ellipsis: true,
            align: 'center',
            filter: <Table.FilterText />,
            getValue : record => {
                switch (record.reqType) {
                    case "ADD":
                        return '新增';
                    case "UPT":
                        return '修改';
                    case "DEL":
                        return '删除';
                    default:
                        return record.reqType;
                }
            },
        },
        {
            title: '模件类型',
            dataIndex: 'moduleType',
            width: 180,
            ellipsis: true,
            filter: <Table.FilterText />,
            getValue: record => {
                const bizNodeTypeName = convertToBizNodeTypeName(record.moduleType, null, record.subTypeCode)
                return bizNodeTypeName;
            },
            render: (text, record) => {
                return <BizNodeTypeTag bizNodeType={record.moduleType} subTypeCode={record.subTypeCode} />
            }
        },
    ];


    const formCss = {
        '.ant-form-item': {
            marginBottom: 0,
        }
    }

    const dpTypeSearch = (inputValue, option) => {
        return option?.children?.toLowerCase().indexOf(inputValue?.toLowerCase()) >= 0 ? true : false;
    }


    return (
        <Modal
            title={"选择增量需求"}
            width={1200}
            style={{ top: 20 }}
            bodyStyle={{overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '80vh', minHeight: 320, background: '#fff', padding: 12, gap: 12}}
            onOk={handleOk}
            {...props}
        >

            <div style={{flexShrink: 0,}}>
                <Form size={'small'} form={form} onFinish={doSearch} css={formCss}>
                    <Row gutter={24}>
                        <Col span={6}>
                            <Form.Item name="reqNo" label="业务需求单编号">
                                <Input placeholder="请输入" allowClear={true}/>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item name="lsrfName" label="软件SPEC单标题">
                                <Input  placeholder="请输入" allowClear={true}/>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item name="reqTitle" label="增量需求">
                                <Input  placeholder="请输入" allowClear={true}/>
                            </Form.Item>
                        </Col>

                        <Col span={6} offset={0} style={{ textAlign: 'right' }}>
                            <Button onClick={doReset} style={{ margin: '0 8px' }}>重置</Button>
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>查询</Button>
                        </Col>
                    </Row>
                </Form>
            </div>

            <div style={{overflow: 'hidden', display: 'flex', flexDirection: 'column', background: '#fff', flexGrow: 1, padding: 0}}>
                <Table
                    code='selectIsrfReq-list'
                    loading={loading}
                    columns={columns}
                    dataSource={data}
                    rowKey={"pkid"}
                    rowSelection={{ type: "checkbox", ...rowSelection }}
                />
            </div>
        </Modal>
    );
}

export default Dialog;